import { makeMutation } from '@/helpers/vuex';

const setIsUserMember = makeMutation('isUserMember');
const setIsSubmitBtnDisabled = makeMutation('isSubmitBtnDisabled');
const setIsDisabledVerifyOTPBtn = makeMutation('isDisabledVerifyOTPBtn');
const setValidateErrorMsg = makeMutation('validateErrorMsg');
const setAuthCode = makeMutation('authCode');
const setIsVerifyOTPLimit = makeMutation('isVerifyOTPLimit');

const defaultState = {
  isUserMember: false,
  isSubmitBtnDisabled: false,
  isDisabledVerifyOTPBtn: false,
  validateErrorMsg: '',
  authCode: '',
  isVerifyOTPLimit: false, // 驗證碼錯誤次數是否已達上限
};

export default {
  namespaced: true,
  state: Object.assign({}, defaultState),
  mutations: {
    setIsUserMember,
    setIsSubmitBtnDisabled,
    setIsDisabledVerifyOTPBtn,
    setValidateErrorMsg,
    setAuthCode,
    setIsVerifyOTPLimit,
    /** 重置 store */
    RESET_STATE(state) {
      Object.keys(defaultState).forEach((prop) => {
        state[prop] = defaultState[prop];
      });
    },
  },
};
